<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" class="filled" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-30">
          Шинэ ажилтан * FAQ
          <div class="row">
            <div v-for="(f) in 12" class="bg-white rounded-20 mg-b-20 pd-20 cols-3 mg-r-20">
              <div>Цалингийн данс хэрхэн нээлгэх /хаалгах/ вэ?</div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>

    </div>




    
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

export default {
  components: {
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      welcomes:[
        {id: 1, title: 'IQ шалгалт', img: '', color: '', id: 0, cols: 6, h: 280, bg: 'linear-gradient(135.15deg, #9C14F2 2.15%, #9627DD 65.39%, #B255EC 98.4%)',
          bgimg: 'apps/golomt/bg-exam-1.png'
         },
        {title: 'MQ шалгалт', img: '', color: '', id: 0, cols: 6, h: 280, bg: ' linear-gradient(135.15deg, #FD709A 2.15%, #E43055 65.39%, #F26E7A 98.4%)',
          bgimg: 'apps/golomt/bg-exam-2.png'
         },
        {title: 'EQ шалгалт', img: '', color: '', id: 0, cols: 4, h: 350, bg: ' linear-gradient(135.15deg, #34BDBD 2.15%, #12A0A1 65.39%, #37BABC 98.4%)',
          bgimg: 'apps/golomt/bg-exam-3.png'
         },
        {title: 'TQ шалгалт', img: '', color: '', id: 0, cols: 4, h: 350, bg: ' linear-gradient(135.15deg, #33B7FF 2.15%, #17A0E2 65.39%, #17A0E2 98.4%)' ,
          bgimg: 'apps/golomt/bg-exam-4.png'
        },
        {title: 'Мэргэжлийн шалгалт', img: '', color: '', id: 0, cols: 4, h: 350, bg: 'linear-gradient(135.15deg, #3AC37A 2.15%, #33BF75 65.39%, #55EB9B 98.4%)' ,
          bgimg: 'apps/golomt/bg-exam-5.png'
        },
      ],
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
  },
  destroyed() {
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
    },
    
  },
};
</script>